import React from "react";

export default function Header() {
  return (
    <header>
      <center>
        <h1>Megan's Recipes</h1>
        <p>meganpaffrath.com</p>
      </center>
    </header>
  )
}